import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { DateColumnFormatter, StatusColumnFormatter } from '../column-formatters/index'
import { currencyFormatter } from '../../../../../../../../_metronic/_helpers';
import { Link } from "react-router-dom";
import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage, toastOption,
} from '../../../../../../../../_metronic/_helpers';
import { Pagination } from '../../../../../../../../_metronic/_partials/controls';
import { toast } from "react-toastify";
import * as columnFormatters from '../../../reconcile-table/column-formatters';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';


// import { act } from 'react-dom/test-utils';

export const ReconcileList = ({ ReconcileList, removeDonationFromReconcile, status }) => {
    // Reconcile UI Context
    // console.log('====================================');
    // console.log(ReconcileList);
    // console.log('====================================');
    // Table columns
    const columns = [
        {
            dataField: 'donation.donation_hid',
            text: 'Donation HID',
        },
        {
            dataField: 'donation.trx_date',
            text: 'Tanggal Donasi',
            formatter: columnFormatters.DateColumnFormatter,
        },
        {
            dataField: 'payment_method.name',
            text: 'Cara Pembayaran',
        },
        {
            dataField: 'amount',
            text: 'Jumlah',
            headerClasses: 'text-right',
            classes: 'text-right',
            formatter: function (val) {
                return currencyFormatter(val)
            },
        },
        // {
        //     dataField: 'trx_date',
        //     text: 'Tanggal Donasi',
        //     formatter: columnFormatters.DateColumnFormatter,
        // },
        // {
        //     dataField: 'donor.name',
        //     text: 'Nama Donatur',
        //     formatter: (cell, row) => {
        //         if (row.donor_name) {
        //             return row.donor_name
        //         } else {
        //             return row.donor.name
        //         }
        //     }
        // },
        // {
        //     dataField: 'status',
        //     text: 'Status Donasi',
        //     formatter: columnFormatters.StatusColumnFormatter,
        // },

        // {
        //     dataField: 'channel.type',
        //     text: 'Tipe',
        //     formatter: (cell, row) => {
        //         if (row.channel_type) {
        //             return row.channel_type
        //         } else {
        //             return row.channel.type
        //         }
        //     }
        // },
        // {
        //     dataField: 'channel.name',
        //     text: 'Nama Channel',
        //     formatter: (cell, row) => {
        //         if (row.channel_name) {
        //             return row.channel_name
        //         } else {
        //             return row.channel.name
        //         }
        //     }
        // },
        // {
        //     dataField: 'total_amount',
        //     text: 'Jumlah',
        //     headerClasses: 'text-right',
        //     classes: 'text-right',
        //     formatter: function (val) {
        //         return currencyFormatter(val)
        //     },
        // },
        // {
        //     dataField: 'uuid',
        //     text: "Detail",
        //     formatter: (cell, row) => {
        //         return (
        //             <div className="text-center d-flex ">
        //                 <OverlayTrigger
        //                     overlay={<Tooltip id="donation-edit-tooltip">Lihat Detail Donasi</Tooltip>}
        //                 >
        //                     <Link to={`/donasi/${row.uuid}/detail`} className="text-light">
        //                         <button className="d-flex btn btn-primary">
        //                             <i style={{ fontSize: "12px" }} class="fas fa-eye align-self-center"></i>Detail
        //                         </button>
        //                     </Link>
        //                 </OverlayTrigger>
        //             </div>
        //         )


        //     }
        // },
        status !== "SETTLE" && {
            dataField: 'uuid',
            text: 'Actions',
            headerClasses: "text-right",
            formatter: (cell, row) => {
                return <div>
                    <button onClick={() => removeDonationFromReconcile(cell)} className="btn btn-icon btn-light btn-hover-danger btn-sm float-right">
                        <i style={{ fontSize: "12px" }} class="fas fa-trash align-self-center"></i>
                    </button>
                </div>
            }
        },

    ];



    return (
        <>
            <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={ReconcileList === null ? [] : ReconcileList}
                columns={columns}
            >
            </BootstrapTable>
        </>
    )

}